import { render, staticRenderFns } from "./forgetpass.vue?vue&type=template&id=ba1406de&scoped=true"
import script from "./forgetpass.vue?vue&type=script&lang=js"
export * from "./forgetpass.vue?vue&type=script&lang=js"
import style0 from "./forgetpass.vue?vue&type=style&index=0&id=ba1406de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1406de",
  null
  
)

/* custom blocks */
import block0 from "./forgetpass.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports